import { render, staticRenderFns } from "./IconRoute.vue?vue&type=template&id=78436b8b&"
import script from "./IconRoute.vue?vue&type=script&lang=ts&"
export * from "./IconRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports